import * as Inovx from '@shared';
import { apiPostForm } from '@shared/api/apiClient';

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/Annotation`;

interface IViewAnnotationTagApiData extends IVersionedIdentityItem {
    KnowledgeViewID: string;
    FacilityID: string;
    AssetClassID: string;
    Text?: string;
    Target2D?: IVector2D;
    Target3D?: IVector3D;
    TargetBoxMin?: IVector3D;
    TargetBoxMax?: IVector3D;
}

const createAnnotationTagApiFormData = (tag: IViewAnnotationTagApiData) => {
    const form_data = new FormData();

    if (tag.ID) form_data.append("ID", tag.ID);
    if (tag.VersionToken) form_data.append("VersionToken", tag.VersionToken);

    form_data.append("FacilityID", tag.FacilityID)
    form_data.append("AssetClassID", tag.AssetClassID)
    form_data.append("KnowledgeViewID", tag.KnowledgeViewID)
    //form_data.append("View360ID", data.View360ID)

    form_data.append("Text", tag.Text)
    if (tag.Target2D) {
        form_data.append("Target2D.X", tag['Target2D'].X.toString())
        form_data.append("Target2D.Y", tag['Target2D'].Y.toString())
    }
    if (tag.Target3D) {
        form_data.append("Target3D.X", tag['Target3D'].X.toString())
        form_data.append("Target3D.Y", tag['Target3D'].Y.toString())
        form_data.append("Target3D.Z", tag['Target3D'].Z.toString())
    }
    if (tag.TargetBoxMin) {
        form_data.append("TargetBoxMin.X", tag['TargetBoxMin'].X.toString())
        form_data.append("TargetBoxMin.Y", tag['TargetBoxMin'].Y.toString())
        form_data.append("TargetBoxMin.Z", tag['TargetBoxMin'].Z.toString())
    }
    if (tag.TargetBoxMax) {
        form_data.append("TargetBoxMax.X", tag['TargetBoxMax'].X.toString())
        form_data.append("TargetBoxMax.Y", tag['TargetBoxMax'].Y.toString())
        form_data.append("TargetBoxMax.Z", tag['TargetBoxMax'].Z.toString())
    }

    return form_data;
}

const AnnotationServices = { ... Inovx.Shared.Flux.BaseService,
    createAnnotation: async function (tag: IViewAnnotationTagApiData) {
        const form_data = createAnnotationTagApiFormData(tag);

        try {
            return await apiPostForm<IViewAnnotationTagApiData>(`${url}/Create`, form_data, { responseType: 'json' });
        }
        catch (error) {
            this.handleWebApiError(error);
        }
    },
    editAnnotation: async function (tag: IViewAnnotationTagApiData) {
        const form_data = createAnnotationTagApiFormData(tag);
        try {
            return await apiPostForm<IViewAnnotationTagApiData>(`${url}/Update`, form_data, { responseType: 'json' });
        }
        catch (error) {
            this.handleWebApiError(error);
        } 
    },   

    deleteAnnotation: function (annotation: IVersionedIdentityItem) {
        return new Promise<void>((resolve, reject) => {
            this.post(`${url}/Delete`,
                { ID: annotation.ID, VersionToken: annotation.VersionToken },
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    }
};

export default AnnotationServices;